import { render, staticRenderFns } from "./SexRate.vue?vue&type=template&id=fef86d0e&scoped=true&lang=pug&"
import script from "./SexRate.vue?vue&type=script&lang=js&"
export * from "./SexRate.vue?vue&type=script&lang=js&"
import style0 from "./SexRate.vue?vue&type=style&index=0&id=fef86d0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef86d0e",
  null
  
)

export default component.exports